import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ContinuousCarousel from "../../components/ContinuousCarousel/ContinuousCarousel";
import QualitySection from "../../components/QualitySection/QualitySection";
import IngredientsSection from "../../components/IngredientsSection/IngredientsSection";

import heroImage from "../../assets/CalitatePage/calitate.png";
import Carousel1 from "../../assets/CarouselSimple/Miel_dor_medovik_slice.jpg";
import Carousel2 from "../../assets/CarouselSimple/Tort_bucuresti_slice.jpg";
import Carousel3 from "../../assets/CarouselSimple/Tort_chocoamour_amandina_slice.jpg";
import Carousel4 from "../../assets/CarouselSimple/Tort_cioco_cafea_slice.jpg";
import Carousel5 from "../../assets/CarouselSimple/Tort_cioco_zmeura_slice.jpg";
import Carousel6 from "../../assets/CarouselSimple/Tort_emeraude_fistic_zmeura_slice.jpg";
import Carousel7 from "../../assets/CarouselSimple/Tort_fruite_slice.jpg";
import Carousel8 from "../../assets/CarouselSimple/Tort_gateau_slice.jpg";
import Carousel9 from "../../assets/CarouselSimple/Tort_lemonberry_slice.jpg";
import Carousel10 from "../../assets/CarouselSimple/Tort_ruby_dobos_slice.jpg";

const carouselItems = [
  { id: 1, title: "", image: Carousel1 },
  { id: 2, title: "", image: Carousel2 },
  { id: 3, title: "", image: Carousel3 },
  { id: 4, title: "", image: Carousel4 },
  { id: 5, title: "", image: Carousel5 },
  { id: 6, title: "", image: Carousel6 },
  { id: 7, title: "", image: Carousel7 },
  { id: 8, title: "", image: Carousel8 },
  { id: 9, title: "", image: Carousel9 },
  { id: 10, title: "", image: Carousel10 },
];

import { Page, Container, FullImageHero, HeroImage } from "./QualityPageStyles";

export default function QualityPage() {
  const navigate = useNavigate();

  return (
    <Page>
      <FullImageHero>
        <HeroImage src={heroImage} alt="Ahava Cakes" />
      </FullImageHero>

      <Container>
        <QualitySection
          primaryCta={{
            label: "Vezi produse",
            onClick: () => navigate("/"),
          }}
        />

        <IngredientsSection />

        <ContinuousCarousel
          title="Calitate – Esența deserturilor Ahava Cakes"
          subtitle="Alegem cu grijă ingrediente premium"
          description={
            <>
              Cremele noastre sunt fierte tradițional, fără premixuri, fără
              aditivi și fără compromisuri. Fiecare textură, fiecare aromă și
              fiecare strat de prăjitură este gândit pentru a reda experiența
              cofetăriei artizanale adevărate. Produsele Ahava Cakes sunt
              realizate în serii mici, ceea ce înseamnă prospețime garantată,
              stocuri limitate și actualizate zilnic. Pentru noi, calitatea nu
              înseamnă doar ingrediente, ci și emoția pe care o oferă fiecare
              desert: echilibrul perfect între gust autentic, tradiție și
              rafinament modern.{" "}
            </>
          }
          items={carouselItems}
        />
      </Container>
    </Page>
  );
}
